import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import App from './App';


const clientId = document.getElementById('LopiDemo').getAttribute('data-client')
ReactDOM.render(
  <App client={clientId} />, document.getElementById('LopiDemo')
)
